import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Navbar from './Navbar';
import { Issue } from './ViewIssues';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Loader from 'react-loader-spinner';
import Magazine from './Magazine';
import { useDownloadUrl } from './IssueCard';
import FadeIn from 'react-fade-in';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import ReactTooltip from 'react-tooltip';
import { toRoman } from 'roman-numerals';

interface Params {
    id: string;
}

export default function ViewIssue(): ReactElement {
    const { id } = useParams<Params>();
    const history = useHistory();

    const [issue, setIssue] = useState<Issue | null>(null);
    useEffect(() => {
        firebase
            .firestore()
            .collection('issues')
            .doc(id)
            .get()
            .then(snapshot => {
                if (!snapshot.exists) {
                    history.push('/');
                    return;
                }

                const data = snapshot.data() as Omit<Issue, 'id'>;

                setIssue(
                    {
                        ...data,
                        id: snapshot.id,
                    } as Issue
                );

                snapshot
                    .ref
                    .update({
                        views: data.views + 1,
                    });
            });
    }, [id]);

    const url = useDownloadUrl(issue?.url);

    return (
        <div className='issue-page'>
            <Navbar />
            <FadeIn>
                <div className='details'>
                    <Link className='back' to='/all'>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        &nbsp;Back
                    </Link>
                    <h1>
                        {
                            issue ? issue.name : (
                                <span className='title-placeholder' />
                            )
                        }
                    </h1>
                    <h3>
                        {
                            issue ? (
                                <>
                                    Issue&nbsp;
                                    <span className='numeral'>
                                        {
                                            toRoman(
                                                issue.number
                                            )
                                        }
                                    </span>
                                </>
                            ) : (
                                <span className='issue-placeholder' />
                            )
                        }
                    </h3>
                </div>
            </FadeIn>
            {
                issue && url ? (
                    <>
                        <div className='viewer'>
                            <Magazine doc={url} />
                        </div>
                        <div className='bottom-bar'>
                            <p className='view-count'>
                                {
                                    issue.views
                                }
                                &nbsp;view{issue.views === 1 ? '' : 's'}
                            </p>
                            <a
                                className='download'
                                rel='noopener noreferrer'
                                target='_blank'
                                download={`${issue.name}.pdf`}
                                href={url}
                            >
                                <FontAwesomeIcon
                                    icon={faDownload}
                                    data-tip='Download as .pdf'
                                />
                                <ReactTooltip effect='solid' place='top' />
                            </a>
                        </div>
                    </>
                ) : (
                    <div className='loader'>
                        <Loader
                            type='Oval'
                            color='#cacaca'
                        />
                    </div>
                )
            }
        </div>
    );
}
